import type { formPinModeType } from 'BreetHelpers';
import type { ReactNode } from 'react';
import * as yup from 'yup';

export interface IPinAccessGuard {
	children?: ReactNode;
	skip?: boolean;
}

export const breadCrumbHeaderObject: Record<formPinModeType, string> = {
	create: 'Create Transaction PIN',
	update: 'Change Transaction PIN',
	reset: 'Reset Transaction PIN',
};

export interface IConfirmResetAction {
	confirmAction: () => void;
	title: string;
	description: string;
	subDescription?: string;
}

export interface IPinManagementFormWrapper {
	children?: ReactNode;
	title: string;
	isModal?: boolean;
}

export interface IPinStepGuard {
	children?: ReactNode;
	mode: formPinModeType;
	setOTP: (otp: string) => void;
}

export type PREPINRESETSTAGE = 'confirm-reset' | 'verify-otp' | 'children';

export interface IVerifyPassword {
	onPasswordVerified: () => void;
}

export const VerificationPasswordSchema = yup.object().shape({
	password: yup.string().required('Password is required'),
});

export type VerificationPasswordSchemaType = yup.InferType<typeof VerificationPasswordSchema>;
